<template>
  <div class="mb-6">
    <div class="mb-2 section-title flex">
      <div class="flex flex-row w-full">
        <div class="flex flex-grow">
          <i
            class="mr-4"
            :class="icon"
          />
          <span> {{ title }}</span>
        </div>
        <div class="mr-0 pull-right">
          <router-link :to="link">
            <i :class="linkIcon" />
          </router-link>
        </div>
      </div>
    </div>
    <div>
      <div v-if="link" />
      <slot />
    </div>
  </div>
</template>

<script>
export default {
    name: 'WidgetSlotContainer',
    props: {
        title: {
            type: String,
            required: true
        },
        link: {
            type: Object,
            required: false
        },
        linkIcon: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false
        }
    }
}
</script>

<style scoped>

</style>